module.exports = __webpack_public_path__ + "static/posthuman2-451e43e14359c65e0aa1eab77821f88c.jpg";